import React, { useEffect, useState } from "react";
import { Select } from "antd";
import numeral from "numeral";

import "../style.css";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "@ts-digital/vrc";
import {Table} from "antd";

const Option = Select.Option;

const DeadlinesPreview = props => {
  const {    
    deadlinesToShow,
    frequencyVal,
    frequencyType,
    requestBody,
    onChange
  } = props;

  const [isModalVisible, setModalVisible] = useState(false);
  const [currentPageTableReccurring, setCurrentPageTableReccurring]= useState(1);

  useEffect(() => {
    if (isModalVisible) return;
    setCurrentPageTableReccurring(1);
  }, [isModalVisible]);
  
  const columns = [
    {
      title: "Scadenza",
      key: "index",
      dataIndex: "index"/* ,
      style: { minWidth: 150 }*/
    },
    {
      title: "Data scadenza",
      key: "date",
      dataIndex: "date"/* ,
      style: { width: "55%" }*/
    },
    {
      title: "Importo",
      key: "amount",
      dataIndex: "amount",
      align: "right",
      render: (amount) =>  {        
        const iconName = requestBody.payment.type === "item_collect" ? "plus-circle" : "minus-circle";
        return (<>        
          <FontAwesomeIcon
            icon={["fas",  iconName ]}
            style={{ fontSize: 12, color: requestBody.payment.type === "item_collect"  ? "#0d6d80" : "#c53090", marginRight: 8 }}
          />
          {numeral(Math.abs(parseFloat(amount.replace(" €","")))).format("0,0.00")} €
        </>);
      }     
    }
  ];
  let frequencies = ["P1W", "P2W", "P1M", "P2M", "P3M", "P4M", "P6M", "P1Y"];
  let scopes = [];
  for (let item in frequencies) {
    if (frequencies.hasOwnProperty(item)) {
      scopes.push(<Option key={frequencies[item]} value={frequencies[item]}>
        {<FormattedMessage id={`deadlines.frequency.${frequencies[item]}`} />}
      </Option>);
    }
  }
  
  return frequencyType !== "single" && (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 16
      }}
    >
      <div        
        style={{ marginRight: 30, width: "46%" }}
      >
        <div className="labelDialogContent">
          <FormattedMessage id="deadlines.pages.create.frequency" />
        </div>
        <div className="customSelect largeSelect">
          <Select
            dropdownClassName="modalOverlay"
            size="large"
            value={frequencyVal}
            onChange={e =>
              onChange({ ...requestBody, frequencyValue: e.target }, e)
            }
          >
            {scopes}
          </Select>
        </div>
      </div>
      {deadlinesToShow.length !== 0 && (
        <div
          onClick={() => setModalVisible(true)}
          style={{
            display: "flex",
            alignSelf: "flex-end",
            alignItems: "baseline",
            fontSize: 16,
            color: "#0090d1",
            width: "48%",
            cursor: "pointer"
          }}
        >
          <FontAwesomeIcon
            icon={["far", "external-link"]}
            style={{ marginRight: 8 }}
          />
          <FormattedMessage id="deadlines.pages.create.deadlinesPreview" />
        </div>
      )}
      <Modal
        visible={isModalVisible}
        footer={
          <div
            style={{
              height: 56,
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              alignItems: "center"
            }}
          >
            <Button
              onClick={() => setModalVisible(false)}
              size="medium"
              kind="secondary"
            >
              <FormattedMessage id="actions.close" />
            </Button>
          </div>
        }
        title={"Scadenze"}
        onClose={() => {
          setModalVisible(false);
        }}
        type="primary"
      >
        <div
          style={{
            fontSize: "16px",
            marginBottom: "20px",
            marginTop: "20px",
            width: "530px"
          }}
        >
          <FormattedMessage id="deadlines.pages.create.previewText1" />
          <b>{deadlinesToShow.length}</b>
          <FormattedMessage id="deadlines.pages.create.previewText2" />
        </div>
        <div>
          <Table
            style={{width: "100%", maxHeight: "calc(100vh - 240px)"}}
            columns={columns}
            dataSource={deadlinesToShow}
            pagination={{
              defaultPageSize: 6,              
              current:　currentPageTableReccurring,
              showSizeChanger: false, pageSizeOptions: ["10", "20", "30"],
              onChange: (page, pageSize) => {
                setCurrentPageTableReccurring(page);
              }
            }}            
            bordered={false}
            // bodyHeight={275}
          />
        </div>
      </Modal>
    </div>
  );
};

export default DeadlinesPreview;
